import React, { useEffect, Suspense } from "react";
import Map from "./components/map/map";
import { fetchStaticData } from "./services/static-data";
import { useSelector } from "react-redux";
import Navigation from "./components/navigation/navigation";
import "./i18n";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

function App() {
  const { readyWebsocketData } = useSelector((state) => ({
    readyWebsocketData: state.shared.readyWebsocketData,
  }));
  document.title = "Green Transit Map - Център за градска мобилност";
  useEffect(() => {
    if (readyWebsocketData) {
      fetchStaticData();
    }
  }, [readyWebsocketData]);

  return (
    <>
      <Suspense fallback={null}>
        <Navigation />
        <Map />
        <NotificationContainer/>
      </Suspense>
    </>
  );
}

export default App;
